import React from 'react';
import {Navbar, Nav, Button, ButtonGroup} from 'react-bootstrap';
import Icon from './../source/icon.png';

export function TopNavbar()
{
  return(
    <>

      <Navbar id = "navigator" variant="light" sticky="top" headerMode = "none">
          <Navbar.Brand>
            <img
              alt=""
              src= {Icon}
              className="d-inline-block img-thumbnail"
              id = "iconImage"
            />{' '}
          </Navbar.Brand>

          <Nav variant="pills" >
          <ButtonGroup>
            <Button id = "carteronetext" variant = "dark" href="/">Home</Button>
            <Button id = "carteronetext" variant = "dark" href="/Games">Games</Button>
            <Button id = "carteronetext" variant = "dark" href="/Presskits">Presskits</Button>
            </ButtonGroup>
          </Nav>


        </Navbar>
        <br></br>
      </>

  )
}


export default TopNavbar;
